import StreetAddress from 'app/shared/model/StreetAddress';

const PropertyType = ({
    display = '',
    code = null,
} = {}) => ({
    display: String(display),
    code: Number(code),
});

const PropertyOverview = ({
    address = {},
    aliasEncoded = '',
    isArchived = false,
    isAddressEditable = false,
    isMultifamily = false,
    listingAlias = '',
    listingType = {},
    name = '',
    photoUrl = '',
    propertyType = {},
    status = '',
} = {}) => ({
    address: StreetAddress(address),
    aliasEncoded: String(aliasEncoded),
    isArchived: Boolean(isArchived),
    isAddressEditable: Boolean(isAddressEditable),
    isMultifamily: Boolean(isMultifamily),
    listingAlias: String(listingAlias),
    listingType: PropertyType(listingType),
    name: String(name),
    photoUrl: String(photoUrl),
    propertyType: PropertyType(propertyType),
    status: String(status),
});

export default PropertyOverview;
